<template>
  <!-- ケアオーケストレーターユーザー管理 -->
  <div id="ExternalCOSettingUser">
      <div class="labelTitle lable">ケア オーケストレーター　ユーザー<span v-if="mode=='listMode'">管理</span><span v-if="mode=='addMode'">追加</span><span v-if="mode=='editMode'">編集</span></div>
      <div class="result-area">
        <template v-if="mode=='listMode'">
            <b-button class="operationButton is-primary" icon-left="account-multiple-plus" @click="addMode">ユーザー追加</b-button>
            <b-table
                :data="data"
                :paginated="true"
                per-page="10"
                pagination-position="both"
                default-sort="user.first_name"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page">
                <template slot-scope="props">
                <b-table-column field="名前" label="名前" width="150" centered class="breakAll">{{props.row.familyName}} {{props.row.firstName}}</b-table-column>
                <b-table-column field="ID" label="ID" width="150">{{props.row.registedCoUserId}}</b-table-column>
                <b-table-column field="メールアドレス" label="メールアドレス" width="250" class="breakAll">{{props.row.mail}}</b-table-column>
                <b-table-column field="申込み状況" label="申込み状況" width="100" centered>
                    <span :class="getTagClass4CoExternalUserStatus(props.row.applicationStatus)" style="width:100px;">{{props.row.applicationStatus | coExternalStatusFilter}}</span>
                </b-table-column>
                <b-table-column field="申込日" label="申込日" width="100" centered>{{props.row.applicationDate}}</b-table-column>
                <b-table-column field="完了日" label="完了日" width="100" centered>{{props.row.completionDate}}</b-table-column>
                <b-table-column field="編集" label="編集/削除" width="120" centered >
                    <b-button v-if="props.row.applicationStatus==2" class="is-primary" @click="editMode(props.row)" icon-left="account-cog">編集/削除</b-button>
                </b-table-column>
                </template>
            </b-table>
        </template>
        <template v-if="mode=='addMode'">
          <div id="item-contens">
            <template>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>姓<span class="require" /></th><td><input type="text" v-model="newUser.familyName" maxlength="100" class="add" name="ユーザー姓" validate="required" placeholder="セキュリティ対策の為、必ず個人名を入力してください。個人を特定できない場合、申請を取消します。"/></td></tr>
                    <tr><th>名<span class="require" /></th><td><input type="text" v-model="newUser.firstName" maxlength="100" class="add" name="ユーザー名" validate="required" placeholder="セキュリティ対策の為、必ず個人名を入力してください。個人を特定できない場合、申請を取消します。"/></td></tr>
                    <tr v-if="isDealer()"><th>ユーザー区分<span class="require" /></th><td>
                      <div class="block">
                        <b-radio class="td_radio" name="userType" v-model="newUser.userClassification" native-value="医療従事者">医療施設</b-radio>
                        <b-radio class="td_radio" name="userType" v-model="newUser.userClassification" native-value="ディーラー">ディーラー</b-radio>
                      </div></td>
                    </tr>
                    <tr><th style="vertical-align:top;">処方設定<span class="require" /></th><td>
                      <div class="block">
                          <b-radio class="td_radio" name="prescription" v-model="newUser.prescriptionSettings" :native-value="true">操作可</b-radio>
                          <b-radio class="td_radio" name="prescription" v-model="newUser.prescriptionSettings" :native-value="false">操作不可</b-radio>
                          <br><span v-if="isDealer()">※操作可能なユーザーが施設に1人以上存在するように設定してください。</span>
                      </div></td>
                    </tr>
                    <tr><th>希望ユーザーID</th><td></td></tr>
                    <tr><th>第一希望：<span class="require" /></th><td><input type="text" v-model="newUser.userIDFirstChoice" maxlength="20" placeholder="6文字以上20文字以内。英数記号('-','_')のうち2種類を含めてください。" class="add" name="ユーザーID:第一希望" validate="required|userId" id="userId1"/></td></tr>
                    <tr><th>第二希望：<span class="require" /></th><td><input type="text" v-model="newUser.userIDSecondChoice" maxlength="20" placeholder="6文字以上20文字以内。英数記号('-','_')のうち2種類を含めてください。" class="add" name="ユーザーID:第二希望" validate="required|userId" id="userId2"/></td></tr>
                    <tr><th>第三希望：<span class="require" /></th><td><input type="text" v-model="newUser.userIDThirdChoice" maxlength="20" placeholder="6文字以上20文字以内。英数記号('-','_')のうち2種類を含めてください。" class="add" name="ユーザーID:第三希望" validate="required|userId" id="userId3"/></td></tr>
                    <tr><th></th><td>※IDは6文字以上20文字以内。英文字・数字・記号のうち2種類を含めてください。大文字・小文字は区別しません。記号は”-”ハイフン又は”_”アンダースコアを使用してください。</td></tr>
                    <tr><th>メールアドレス<span class="require" /></th><td><input type="text" v-model="newUser.mail" class="add" name="ユーザーメールアドレス" validate="required|mail"  maxlength="256"/></td></tr>
                    <tr><th></th><td>※ID登録完了、パスワードの再発行等はご登録いただいたメールアドレス宛てに、電子メールにてお知らせします。</td></tr>
                    <template v-if="!isDealer()">
                      <tr>
                        <th>ケア　エクスポーター<span class="require"/></th>
                        <td>
                            <div class="block">
                              <b-radio class="td_radio" name="careExporter" v-model="newUser.careExporter" :native-value="true">利用する</b-radio>
                              <b-radio class="td_radio" name="careExporter" v-model="newUser.careExporter" :native-value="false">利用しない</b-radio>
                            </div>
                          </td>
                      </tr>
                      <tr>
                        <th />
                        <td>
                          <!-- TODO: 関連資料を受け取ったらファイルを差し替える。 -->
                          <span class="information_text">
                            ※治療レポートや患者一覧を一括出力することができるオプションツールです。詳細は担当営業にご確認ください。関連資料は<a class="under_line" :href="getUrlCatalog()" target="_blank" rel="noopener noreferrer">こちら</a>
                          </span>
                        </td>
                      </tr>
                    </template>
                  </table>
                </div>
            </template>
            <div class="card-content margin-top">
                <table>
                    <tr><th>■個人情報の管理に関する事項</th><td></td></tr>
                    <tr><td colspan="2" style="padding-left:20px;">
                        申請者は、上記の個人情報がケア　オーケストレーター上で管理されることに同意します。<br>
                        株式会社フィリップス・ジャパンは、当申請書より知り得た個人情報を、ケア　オーケストレーターに関わる運用保守業務以外に使用しません。<br>
                        ID・パスワード忘れに関するお問い合わせは、お電話での回答はできかねますのでご了承ください。<br>
                        異動などの事由により当ユーザーアカウントを使用されなくなった場合には、速やかに弊社営業担当者までお知らせ下さい。<br>
                        また、定期的にユーザーアカウントが使用されているか、確認させていただくことがございます。
                        </td>
                    </tr>
                </table>
            </div>
            <div style="margin-top:10px;">
              <b-button class="is-primary" v-on:click="registUser">追加を申請する</b-button>
              <b-button class="is-primary" v-on:click="cancel">キャンセル</b-button>
            </div>
            <div class="hiddenBackButton"/>
          </div>
        </template>
        <template v-if="mode=='editMode'">
            <div id="item-contens">
                <div class="card-content margin-top">
                  <table>
                      <tr><th>ユーザーID</th><td>{{selectUser.registedCoUserId}}</td></tr>
                      <tr><th>姓</th><td>{{selectUser.familyName}}</td></tr>
                      <tr><th>名</th><td>{{selectUser.firstName}}</td></tr>
                      <tr v-if="isDealer()"><th>ユーザー区分<span class="require" /></th><td>
                        <div class="block">
                          <b-radio class="td_radio" name="userType" v-model="selectUser.userClassification" native-value="医療従事者">医療施設</b-radio>
                          <b-radio class="td_radio" name="userType" v-model="selectUser.userClassification" native-value="ディーラー">ディーラー</b-radio>
                        </div></td>
                      </tr>
                      <tr><th>処方設定<span class="require" /></th><td>
                      <div class="block">
                          <b-radio class="td_radio" name="prescription" v-model="selectUser.prescriptionSettings" :native-value="true">操作可</b-radio>
                          <b-radio class="td_radio" name="prescription" v-model="selectUser.prescriptionSettings" :native-value="false">操作不可</b-radio>
                      </div></td>
                      </tr>
                      <tr><th>メールアドレス<span class="require" /></th><td><input type="text" v-model="selectUser.mail" class="edit" name="ユーザーメールアドレス" validate="required|mail"  maxlength="256"/></td></tr>
                      <tr><th></th><td>※ID登録完了、パスワードの再発行等はご登録いただいたメールアドレス宛てに、電子メールにてお知らせします。</td></tr>
                      <template v-if="!isDealer()">
                        <tr>
                          <th>ケア　エクスポーター<span class="require"/></th>
                          <td>
                              <div class="block">
                                <b-radio class="td_radio" name="careExporter" v-model="selectUser.careExporter" :native-value="true">利用する</b-radio>
                                <b-radio class="td_radio" name="careExporter" v-model="selectUser.careExporter" :native-value="false">利用しない</b-radio>
                              </div>
                            </td>
                        </tr>
                        <tr>
                          <th />
                          <td>
                            <!-- TODO: 関連資料を受け取ったらファイルを差し替える。 -->
                            <span class="information_text">
                              ※治療レポートや患者一覧を一括出力することができるオプションツールです。詳細は担当営業にご確認ください。関連資料は<a class="under_line" :href="getUrlCatalog()" target="_blank" rel="noopener noreferrer">こちら</a>
                            </span>
                          </td>
                        </tr>
                    </template>
                  </table>
                </div>
              <div style="margin-top:10px;">
                <b-button class="is-primary" v-on:click="changeRegist">変更を申請する</b-button>
                <b-button class="is-primary" v-on:click="deletRegist">削除を申請する</b-button>
                <b-button class="is-primary" v-on:click="cancel">キャンセル</b-button>
              </div>
              <div class="hiddenBackButton"/>
            </div>
        </template>
      </div>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
// ユーザー情報
const userInformation = {
  familyName: "",
  firstName: "",
  userClassification: "医療従事者",
  prescriptionSettings: true,
  userIDFirstChoice: "",
  userIDSecondChoice: "",
  userIDThirdChoice: "",
  mail: "",
};
// 医療機関のみの項目
const institutionItem = {
  careExporter: false
};
export default {
  name: "ExternalCOSettingUser",
  methods: {
    editMode: function(userInfo) {
      this.selectUser = userInfo;
      this.mode = "editMode";
    },
    addMode: function() {
      this.newUser = !this.isDealer() ? { ...userInformation, ...institutionItem } : { ...userInformation },
      this.mode = "addMode";
    },
    registUser: function(){
      // ユーザー追加
      // バリデーションチェック
      var elements = document.getElementsByClassName("add")
      var result = this.selfMadeValidation(elements)
      var userID1Element = document.getElementById('userId1');
      var userID2Element = document.getElementById('userId2');
      var userID3Element = document.getElementById('userId3');
      var ErrFlag = false
      if(this.newUser.userIDFirstChoice && this.newUser.userIDSecondChoice && this.newUser.userIDThirdChoice){
        if(this.newUser.userIDFirstChoice.toUpperCase() == this.newUser.userIDSecondChoice.toUpperCase()){
          // 第一希望と第二希望
          result.msg = result.msg + "希望ユーザーIDが重複しています。\n"
          ErrFlag = true
          userID1Element.style["border-color"] = "red";
          userID2Element.style["border-color"] = "red";
        }
        if(this.newUser.userIDFirstChoice.toUpperCase() == this.newUser.userIDThirdChoice.toUpperCase()){
          // 第一希望と第三希望
          if(!ErrFlag){
            result.msg = result.msg + "希望ユーザーIDが重複しています。\n"
            ErrFlag = true
          }
          userID1Element.style["border-color"] = "red";
          userID3Element.style["border-color"] = "red";
        }
        if(this.newUser.userIDSecondChoice.toUpperCase() == this.newUser.userIDThirdChoice.toUpperCase()){
          // 第二希望と第三希望
          if(!ErrFlag){
            result.msg = result.msg + "希望ユーザーIDが重複しています。\n"
            ErrFlag = true
          }
          userID2Element.style["border-color"] = "red";
          userID3Element.style["border-color"] = "red";
        }
      }
      if(result.msg){
        this.showErrorMessage(result.msg)
      }else{
        userID1Element.style["border-color"] = "";
        userID2Element.style["border-color"] = "";
        userID3Element.style["border-color"] = "";
        // 登録処理
        var excuteApi = this.setCoSettingUserManagementAdditionPOST;
        var successCallBack = this.setCoSettingUserManagementAdditionPOSTSuccess;
        var errorCallBack = this.setCoSettingUserManagementAdditionPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    setCoSettingUserManagementAdditionPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.newUser));
      obj.careOrchestratorInstitutionId = this.careOrchestratorInstitutionId
      obj.belongsId = this.belongsId
      return client.apis.externalCOSetting.setCoSettingUserManagementAdditionPOST({
        body:obj
      });
    },
    setCoSettingUserManagementAdditionPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.mode = "listMode";
      this.doSearch();
    },
    setCoSettingUserManagementAdditionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    changeRegist: function(){
      // 変更申請
      // バリデーションチェック
      var elements = document.getElementsByClassName("edit")
      var result = this.selfMadeValidation(elements)
      if(result.isError){
        this.showErrorMessage(result.msg)
      }else{
        // 変更処理
        var excuteApi = this.setCoSettingUserManagementUpdatePOST;
        var successCallBack = this.setCoSettingUserManagementUpdatePOSTSuccess;
        var errorCallBack = this.setCoSettingUserManagementUpdatePOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    setCoSettingUserManagementUpdatePOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.selectUser));
      obj.careOrchestratorInstitutionId = this.careOrchestratorInstitutionId
      obj.belongsId = this.belongsId
      return client.apis.externalCOSetting.setCoSettingUserManagementUpdatePOST({
        body:obj
      });
    },
    setCoSettingUserManagementUpdatePOSTSuccess: function(result) {
      this.showSuccess(result);
      this.mode = "listMode";
      this.doSearch();
    },
    setCoSettingUserManagementUpdatePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    deletRegist: function(){
      // 削除申請
      var excuteApi = this.setCoSettingUserManagementDeletePOST;
      var successCallBack = this.setCoSettingUserManagementDeletePOSTSuccess;
      var errorCallBack = this.setCoSettingUserManagementDeletePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCoSettingUserManagementDeletePOST: function(client) {
      return client.apis.externalCOSetting.setCoSettingUserManagementDeletePOST({
        body:{
          userId:this.selectUser.userId,
          careOrchestratorInstitutionId:this.selectUser.careOrchestratorInstitutionId,
          belongsId:this.belongsId
          }
      });
    },
    setCoSettingUserManagementDeletePOSTSuccess: function(result) {
      this.showSuccess(result);
      this.mode = "listMode";
      this.doSearch();
    },
    setCoSettingUserManagementDeletePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cancel: function(){
      // キャンセル
      this.doSearch();
      this.mode = "listMode";
      this.selectUser = null;
    },
    isDealer: function(){
      return this.roleId == this.role.role_dealer;
    },
    doSearch: function() {
      var excuteApi = this.getCoSettingUserListPOST;
      var successCallBack = this.getCoSettingUserListPOSTSuccess;
      var errorCallBack = this.getCoSettingUserListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCoSettingUserListPOST: function(client) {
      return client.apis.externalCOSetting.getCoSettingUserListPOST({
        body:{
          careOrchestratorInstitutionId: this.careOrchestratorInstitutionId
        }
      });
    },
    getCoSettingUserListPOSTSuccess: function(result) {
      var _this = this;
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // 削除済みの場合にホームに戻す
      if (result.body.isCancel) {
        this.$dialog.alert({title: '　', message: "ケア オーケストレーターの利用申込みを行って下さい。"})
        userInfo.coType = 1
        userInfo.CoApplicationReceiptNumber = 0
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        _this.$router.push({ path: "/guest/home" });
      } else {
        // 検索結果取得
        this.data = result.obj
      }
    },
    getCoSettingUserListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    return {
      role: role,
      roleId: userInfo.roleId,
      data : [],
      mode: "listMode",
      selectUser: null,
      newUser: {},
      careOrchestratorInstitutionId: careOrchestratorInstitutionId,
      belongsId:userInfo.belongsId
    };
  },
  async mounted() {
    await this.doSearch();
  },
  filters: {},
  components: {
  },
};
</script>
<style lang="scss" scoped>
.urgency_caution {
    color: red;
}
.hiddenBackButton {
  width:100%;
  height: 100px;
  margin-top:5px;
  background-color: white;
  position: absolute;
  z-index: 1;
}
.under_line {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/setting/ExternalUserContents.vue